/**
 * Get nested attribute value using dot notation path
 *
 * @param attributes - Current block attributes
 * @param path - Dot notation path
 * @param defaultValue - Default value if path doesn't exist
 * @returns Value at path or default value
 */
export const getAttribute = < T, TValue = unknown >(
	attributes: T,
	path: string,
	defaultValue?: TValue,
): TValue => {
	const pathParts = path.split( '.' );
	let current: unknown = attributes;

	for ( const part of pathParts ) {
		if (
			current &&
			typeof current === 'object' &&
			part in ( current as Record< string, unknown > )
		) {
			current = ( current as Record< string, unknown > )[ part ];
		} else {
			return defaultValue as TValue;
		}
	}

	return ( current ?? defaultValue ) as TValue;
};
